"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onlyRenderFailedIfNoData = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const isEmptyDefault = data => !data || Array.isArray(data) && data.length === 0 || JSON.stringify(data) === '{}';
const onlyRenderFailedIfNoData = _ref => {
  let {
    isLoading,
    hasError,
    isEmpty
  } = _ref;
  return !isLoading && hasError && isEmpty;
};
exports.onlyRenderFailedIfNoData = onlyRenderFailedIfNoData;
const WaitForData = _ref2 => {
  let {
    queryResult,
    loadingMsg,
    failedInitial,
    noContent,
    message403,
    action403,
    children,
    passRefetch,
    LoadingComponent,
    FailedLoadComponent,
    NoContentComponent,
    isEmpty,
    shouldRenderIsLoadingComponent,
    shouldRenderFailedComponent,
    shouldRenderNoContentComponent
  } = _ref2;
  const {
    data,
    errorStatusCode
  } = queryResult;
  const params = {
    ...queryResult,
    isEmpty: isEmpty(data)
  };
  if (shouldRenderIsLoadingComponent(params)) {
    return /*#__PURE__*/React.createElement(LoadingComponent, {
      message: loadingMsg
    });
  }
  if (shouldRenderFailedComponent(params)) {
    return /*#__PURE__*/React.createElement(FailedLoadComponent, {
      errorStatusCode: errorStatusCode,
      message403: message403,
      action403: action403,
      message: failedInitial || 'General.Error',
      onAction: passRefetch ? queryResult.refetch : null
    });
  }
  if (shouldRenderNoContentComponent(params)) {
    return /*#__PURE__*/React.createElement(NoContentComponent, {
      message: noContent || 'General.Error',
      onAction: passRefetch ? queryResult.refetch : null
    });
  }
  return children(params);
};
WaitForData.defaultProps = {
  failedInitial: 'General.Error',
  noContent: 'General.Error',
  loadingMsg: null,
  onAction: null,
  action403: null,
  passRefetch: true,
  isEmpty: isEmptyDefault,
  shouldRenderIsLoadingComponent: _ref3 => {
    let {
      isEmpty,
      isLoading
    } = _ref3;
    return isEmpty && isLoading;
  },
  shouldRenderFailedComponent: _ref4 => {
    let {
      isLoading,
      hasError
    } = _ref4;
    return !isLoading && hasError;
  },
  shouldRenderNoContentComponent: _ref5 => {
    let {
      isLoading,
      hasError,
      isEmpty,
      warning
    } = _ref5;
    return !isLoading && !hasError && !warning && isEmpty;
  }
};
var _default = exports.default = WaitForData;